import { ValueOf } from "src/types.d"

export const RootTabs = Object.freeze({
  NotificationTab: "NotificationTab",
  ContactNetworkDrawer: "ContactNetworkDrawer",
  OrganizationManagerTab: "OrganizationManagerTab",
  SettingsTab: "SettingsTab",
} as const)

export type RootTabs = ValueOf<typeof RootTabs>
